; (function ($) {
    let beerShowcaseNavOptions = {
        infinite: true,
        arrows: false,
        dots: false,
        centerMode: true,
        slidesToShow: 1,
        asNavFor: '.info-container'
    }
    let beerShowcaseSlideOptions = {
        infinite: true,
        arrows: false,
        fade: true,
        dots: false,
    }

    $(document).ready(function () {
        
        $('.info-container').slick(beerShowcaseSlideOptions);

       
        
        if (window.matchMedia("(max-width: 768px)").matches) {
            $('.top-can-container').slick(beerShowcaseNavOptions);  
        } else {

            $('.can-container').each((i, e) => {
                $(e).click(() => {
                    let position = $(e).position();
                    $('.active-can-wedge').css('left', position.left)
                    $('.info-container').slick('slickGoTo', i)
               })
            })

            $('.info-container').on('afterChange', function(event, slick, currentSlide){
                $('.can-container').each((i, e) => {
                    if (i === currentSlide) {
                        let position = $(e).position();
                        $('.active-can-wedge').css('left', position.left)
                    }
                 })
            });
        }

    });
  
  })(jQuery);
  